import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MediaTypeGroupsPage as Component } from './MediaTypeGroupsPage'
import { AppStateType } from '../../reducers'
import { selectMediaTypeGroups } from '../../selectors/mediaTypesGroups'
import { selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'

const mapStateToProps = (state: AppStateType) => ({
  mediaTypeGroups: selectMediaTypeGroups(state),
  canAddMediaTypeGroup: selectAreaReadable(state, { area: AREA_CONSTANTS.SETTINGS_CREATE_MEDIA_TYPE_GROUP }),
})

export const MediaTypeGroupsPage = withRouter(connect(mapStateToProps)(Component))
